import { AxiosRequestConfig } from 'axios';
import { currentLanguage } from 'shared/constants/common';
import { findCookieValue } from 'shared/util/utility';

const KuponKibicaWrapper = (requests: any) => {
	return {
		getKuponKibica: (id: string) => {
			const config: AxiosRequestConfig = {
				headers: {
					'Request-Language': currentLanguage,
					'x-odds-session': findCookieValue('x-odds-session'),
				},
			};
			return requests.get('/kupon-kibica/' + id, config);
		},
		takeScreenshotOfKuponKibica: (id: number, name: string) => {
			return requests.get(`kupon-kibica/${id}/share/${name}`);
		},
	};
};

export default KuponKibicaWrapper;
